/*
Author: Chathuraka Mallawa Arachchi
Date: 18/10/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for form applying validations based on question type
*/


import {AdvancedMultiChoiceCheckbox,DateRangeMatrixType,QuestionTextOnly,RepeatableMatrix} from "@/constants/constants"
import {BasicAnswerSave} from "@/state/survey/saveAnswerSlice"
import answerDetails from "../abstract/answerDetails"
import {DateRangeType,FormState} from "../types/commonTypes"
import {INode} from "../types/nodeTypes"

const patientAnswerDetails = (function () {

    const generateQuestionAnswerSubmitFormat = (form: FormState, node: INode): BasicAnswerSave []=> {
        switch(node.type){
            case DateRangeMatrixType :{
       
                const answers : BasicAnswerSave[] = []
                let answerValues:  DateRangeType[] = []
                if(form[node.name] && form[node.name]?.value && typeof form[node.name]?.value === 'string' ) {
                    answerValues = JSON.parse(form[node.name]?.value as string)
                }
                
                const answerObject: BasicAnswerSave = {
                    name: node.name,
                    value: answerValues as DateRangeType[]
                }
                
                answers.push(answerObject)
                return answers;

            }
            case QuestionTextOnly: {
                const answerObject = form[node.name]?.value;
                
                if (answerDetails.isBasicAnswerSaveArray(answerObject)) {
                    return answerObject;
                } else {
                    throw new Error('Invalid data: answerObject does not match BasicAnswerSave[]');
                }
            
            }
            case RepeatableMatrix:
            case AdvancedMultiChoiceCheckbox: {
                const answers : BasicAnswerSave[] = []
                const answerValues = JSON.parse(form[node.name]?.value as string)
                const answerObject: BasicAnswerSave = {
                    name: node.name,
                    value: answerValues
                }
                answers.push(answerObject)
                return answers;
            }
            default:{
                return answerDetails.setNameAndValue(node, form)
            }        
        }
    }
    return {
        generateQuestionAnswerSubmitFormat,
    }
})()

export default patientAnswerDetails
